import { Input, MultySelect, Select, Switch, Textarea } from '../../..';
import {
  accessOptions,
  addTools,
  categoryList,
  colorOption,
  complexityList,
  cookingStepExample,
  countries,
  fieldPlaceholder,
  garnishList,
  glasswareOptions,
  group,
  mainIngredients,
  methodMaking,
  strengthList,
  tasties,
  timeForCocktailList,
  tools,
  typeServing,
  typesOfIce,
  volumeOptions,
} from '../config';
import { ICoctail, TLanguage } from '../../../../types';
import AddingIngredients from '../../AddingIngredients/AddingIngredients';
import { sortOptions } from '../../../../lib';
import { Dispatch, SetStateAction, useCallback } from 'react';

const InfoBlock = ({
  lang,
  coctail,
  changeSteps,
  changeDescription,
  setCoctail,
}: {
  lang: TLanguage;
  coctail: ICoctail;
  changeSteps: (value: string, lang: TLanguage) => void;
  changeDescription: (value: string, lang: TLanguage) => void;
  setCoctail: Dispatch<SetStateAction<ICoctail>>;
}) => {
  const errorMessage = lang === 'eng' ? 'Required field' : 'Поле обязательно для заполнения';

  const onChangeSteps = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeSteps(e?.target?.value, lang);
  };

  const onChangeDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeDescription(e?.target?.value, lang);
  };

  // const onChangeSelect = useCallback(
  //   (field: string) => (value: string) => {
  //     console.log(field, value, lang);
  //     console.log(coctail);
  //     if (lang === 'ru') {
  //       setCoctail(prev => ({ ...prev, eng: { ...prev.eng, [field]: value } }));
  //     } else if (lang === 'eng') {
  //       setCoctail(prev => ({ ...prev, ru: { ...prev.ru, [field]: value } }));
  //     }
  //   },
  //   [],
  // );

  return (
    <>
      <div style={{ marginBottom: '40px' }}>
        <Select
          name={`${lang}_access`}
          options={sortOptions(accessOptions[`${lang}`])}
          label={fieldPlaceholder.access[lang]}
          placeholder={fieldPlaceholder.access[lang]}
          errorMessage={errorMessage}
        />
        <Input
          name={`${lang}_name`}
          placeholder={fieldPlaceholder.name[lang]}
          label={fieldPlaceholder.name[lang]}
          errorMessage={errorMessage}
          size="middle"
        />
        <Textarea
          name={`${lang}_description`}
          label={fieldPlaceholder.description[lang]}
          placeholder={fieldPlaceholder.description[lang]}
          defaultValue={coctail?.[lang]?.description}
          onChangeValue={onChangeDescription}
        />
      </div>
      <div style={{ marginBottom: '40px' }}>
        <MultySelect
          name={`${lang}_category`}
          options={sortOptions(categoryList[`${lang}`])}
          errorMessage={errorMessage}
          label={fieldPlaceholder.category[lang]}
          placeholder={fieldPlaceholder.category[lang]}
        />
        <Select
          options={sortOptions(group[`${lang}`])}
          name={`${lang}_group`}
          placeholder={fieldPlaceholder.group[lang]}
          label={fieldPlaceholder.group[lang]}
          errorMessage={errorMessage}
          // onChange={onChangeSelect('group')}
        />
        <Select
          options={sortOptions(typeServing[`${lang}`])}
          name={`${lang}_typeServing`}
          placeholder={fieldPlaceholder.typeServing[lang]}
          label={fieldPlaceholder.typeServing[lang]}
          errorMessage={errorMessage}
        />
        <Select
          name={`${lang}_difficulty`}
          options={sortOptions(complexityList[`${lang}`])}
          label={fieldPlaceholder.difficulty[lang]}
          placeholder={fieldPlaceholder.difficulty[lang]}
          errorMessage={errorMessage}
        />
        <MultySelect
          name={`${lang}_methodMaking`}
          options={sortOptions(methodMaking[`${lang}`])}
          errorMessage={errorMessage}
          label={fieldPlaceholder.method[lang]}
          placeholder={fieldPlaceholder.method[lang]}
        />
        <MultySelect
          name={`${lang}_timeForCocktail`}
          options={sortOptions(timeForCocktailList[`${lang}`])}
          label={fieldPlaceholder.timeForCocktail[lang]}
          placeholder={fieldPlaceholder.timeForCocktail[lang]}
        />
        <Switch label={fieldPlaceholder.vegan[lang]} name={`${lang}_isVegan`} />
      </div>
      <div style={{ marginBottom: '40px' }}>
        <Select
          name={`${lang}_volume`}
          options={sortOptions(volumeOptions[`${lang}`])}
          label={fieldPlaceholder?.volume[lang]}
          placeholder={fieldPlaceholder?.volume[lang]}
          errorMessage={errorMessage}
        />
        <Select
          name={`${lang}_color`}
          options={sortOptions(colorOption[`${lang}`])}
          placeholder={fieldPlaceholder.color[lang]}
          label={fieldPlaceholder.color[lang]}
          errorMessage={errorMessage}
        />
        <MultySelect
          name={`${lang}_flavor`}
          options={sortOptions(tasties[`${lang}`])}
          errorMessage={errorMessage}
          label={fieldPlaceholder.taste[lang]}
          placeholder={fieldPlaceholder.taste[lang]}
        />
        <Input
          name={`${lang}_degrees`}
          placeholder={fieldPlaceholder.degrees[lang]}
          label={fieldPlaceholder.degrees[lang]}
          errorMessage={errorMessage}
          size="middle"
          type="number"
        />
        <Select
          name={`${lang}_strength`}
          options={sortOptions(strengthList[`${lang}`])}
          label={fieldPlaceholder.strength[lang]}
          placeholder={fieldPlaceholder.strength[lang]}
          errorMessage={errorMessage}
        />
      </div>
      <div style={{ marginBottom: '40px' }}>
        <MultySelect
          name={`${lang}_glassware`}
          options={sortOptions(glasswareOptions[`${lang}`])}
          errorMessage={errorMessage}
          label={fieldPlaceholder.glass[lang]}
          placeholder={fieldPlaceholder.glass[lang]}
        />
        <MultySelect
          name={`${lang}_tools`}
          options={sortOptions(tools[`${lang}`])}
          errorMessage={errorMessage}
          label={fieldPlaceholder.tools[lang]}
          placeholder={fieldPlaceholder.tools[lang]}
        />
        <MultySelect
          name={`${lang}_addTools`}
          options={sortOptions(addTools[`${lang}`])}
          label={fieldPlaceholder.addTools[lang]}
          placeholder={fieldPlaceholder.addTools[lang]}
        />
      </div>
      <div style={{ marginBottom: '40px' }}>
        <Select
          name={`${lang}_baseSpirit`}
          options={sortOptions(mainIngredients[`${lang}`])}
          label={fieldPlaceholder.baseSpirit[lang]}
          placeholder={fieldPlaceholder.baseSpirit[lang]}
          errorMessage={errorMessage}
        />
        <MultySelect
          name={`${lang}_typeIce`}
          options={sortOptions(typesOfIce[`${lang}`])}
          label={fieldPlaceholder.typesOfIce[lang]}
          placeholder={fieldPlaceholder.typesOfIce[lang]}
        />
        <MultySelect
          name={`${lang}_garnish`}
          options={sortOptions(garnishList[`${lang}`])}
          label={fieldPlaceholder.garnish[lang]}
          placeholder={fieldPlaceholder.garnish[lang]}
        />
        <AddingIngredients initialValues={coctail?.[lang].ingredients} lang={lang} />
        <Textarea
          name={`${lang}_cookingSteps`}
          label={fieldPlaceholder.cookingSteps[lang]}
          placeholder={fieldPlaceholder.cookingSteps[lang]}
          defaultValue={
            !!coctail?.[lang]?.cookingSteps
              ? JSON?.stringify(coctail?.[lang]?.cookingSteps, undefined, 5)
              : ''
          }
          onChangeValue={onChangeSteps}
          row={15}
          example={cookingStepExample}
          errorMessage={errorMessage}
        />
      </div>
      <div style={{ marginBottom: '40px' }}>
        <Select
          name={`${lang}_country`}
          options={sortOptions(countries[`${lang}`])}
          placeholder={fieldPlaceholder.country[lang]}
          label={fieldPlaceholder.country[lang]}
        />
        <Input
          name={`${lang}_origin`}
          placeholder={fieldPlaceholder.origin[lang]}
          label={fieldPlaceholder.origin[lang]}
          size="middle"
        />
      </div>
    </>
  );
};

export default InfoBlock;
